"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M1 21V2a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1zm2 0h8v-8H3v8zm10 0h8v-8h-8v8zm0-18v8h8V3h-8zm-2 0H3v8h8V3z"
}));